<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="navMenuItems" />
  </div>
</template>

<script>
import { filtrarMenuPorPermisos } from '@/utils/filtrarNavegacion'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
  components: {
    HorizontalNavMenuItems,
  },

  data() {
    return {
      navMenuItems: [],
      userPermisos: JSON.parse(localStorage.getItem('permisos')),
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },

  mounted() {
    try {
      const permisos = JSON.parse(this.userPermisos || '{}')
      this.navMenuItems = filtrarMenuPorPermisos(permisos, this.userData)
    } catch (error) {
      console.error('Error al cargar permisos:', error)
      this.navMenuItems = []
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
